// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__PropertyDetailsPolChangePage__page-header-gap-closer{margin-top:-55px!important}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-policychange-ho-react/pages/PropertyDetails/PropertyDetailsPolChangePage.module.scss"],"names":[],"mappings":"AAAA,2DACI,0BAAA","sourcesContent":[".page-header-gap-closer{\n    margin-top: -55px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-header-gap-closer": "app__PropertyDetailsPolChangePage__page-header-gap-closer"
};
export default ___CSS_LOADER_EXPORT___;
